import React from "react";
import "./DynamicTable.css";
import Autosuggest from "react-autosuggest";
import { object } from "yup";
import Popup from "reactjs-popup";
import "./Form.css";

class DynamicTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [{}],
      focusOnAddRow: true,
      showErrorPopup: false,
      errorMessage: "",
    };
    let rowsDummy = [{}];
    for (var tableItem of this.props.tableItems) {
      rowsDummy[0][tableItem.name] = "";
    }
    this.props.setPageStateByField(this.props.fieldMapping, rowsDummy);
  }
  handleChange = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.props.pageStateArray];
    rows[idx][name] = value;
    // this.setState({
    //   rows,
    // });  
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };
  handleChangeByField = (name, value, idx) => {
    const rows = [...this.props.pageStateArray];
    rows[idx][name] = String(value);
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  updateSuggestionValueInState = (idx, objectToUpdate) => {
    const rows = [...this.props.pageStateArray];
    let rowObject = rows[idx];
    rowObject = { ...rowObject, ...objectToUpdate };
    rows[idx] = rowObject;
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };
  handleAddRow = () => {
    const isBbacToBeBilled =
      process.env.REACT_APP_CLIENT === "bbac" &&
      this.props.fieldMapping === "item_in" &&
      String(this.props.pageState?.pay_type) === "4";
    const isBbacItemTable =
      process.env.REACT_APP_CLIENT === "bbac" &&
      this.props.fieldMapping === "item_in";
    const lastRow =
      this.props.pageStateArray[this.props.pageStateArray.length - 1] || {};

    if (
      process.env.REACT_APP_CLIENT === "bgtc" &&
      this.props.fieldMapping === "item_in" &&
      this.props.pageStateArray.length >= 6
    ) {
      return;
    }
    /**
     * Check if any field is empty and don't let the row add
     * if any field is empty.
     */
    for (var item_index in this.props.pageStateArray) {
      let item = this.props.pageStateArray[item_index];
      for (var key in item) {
        if (key == "rate_info"){
          continue
        }
        if (key == "truck_size"){
          continue
        }
        if (item[key] == "") {
          return;
        }
      }
    }
    const item = {};
    for (var tableItem of this.props.tableItems) {
        // console.log({tableItem});
      if (tableItem.name == "packing_type") {
        item[tableItem.name] = "1";
        continue;
      }
      if (tableItem.name == "new_row") {
        item[tableItem.name] = "N";
        continue;
      }
      if(tableItem.name == "unit" && this.props.fieldMapping == "item_in") {
        if (isBbacToBeBilled) {
          item[tableItem.name] = "C";
          continue;
        }

        if (isBbacItemTable) {
          item[tableItem.name] = lastRow.unit || "T";
          continue;
        }

        item[tableItem.name] = "C";
        continue;
      }
      
      if (
        (process.env.REACT_APP_CLIENT === "bgtc" || isBbacToBeBilled) &&
        tableItem.name === "weight"
      ) {
        item[tableItem.name] = "0";
        continue;
      }

      if (isBbacItemTable && tableItem.name === "weight") {
        item[tableItem.name] = "0";
        continue;
      }

      if (isBbacItemTable && tableItem.name === "truck_size") {
        item[tableItem.name] = lastRow.truck_size || "9mt";
        continue;
      }

      item[tableItem.name] = "";
    }
    console.log("table item", item);

    this.setState({
      rows: [...this.state.rows, item],
      focusOnAddRow: true,
    });
    this.props.setPageStateByField(this.props.fieldMapping, [
      ...this.props.pageStateArray,
      item,
    ]);
  };

  handleRemoveRow = () => {
    // this.setState({
    //   rows: this.state.rows.slice(0, -1),
    // });
    let rows = this.props.pageStateArray;
    rows = rows.slice(0, -1);
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.props.pageStateArray];
    rows.splice(idx, 1);
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  isDuplicateEwayBill = (currentIndex, value) => {
    if (!value) return false;

    const normalized = String(value).trim();

    return this.props.pageStateArray.some((row, idx) => {
      if (idx === currentIndex) return false;
      return String(row.eway_bill_no || "").trim() === normalized;
    });
  };

  onKeyPress = (e, index, totalLength, fieldInfoObject) => {
    const keyString = String(e.key);
    console.log("inside !!!");

    if (
      process.env.REACT_APP_CLIENT === "bgtc" &&
      this.props.fieldMapping === "eway_bill_no" &&
      fieldInfoObject.name === "eway_bill_no" &&
      keyString === "Enter"
    ) {
      const currentValue =
        this.props.pageStateArray[index]?.eway_bill_no;

      if (currentValue) {
        const normalized = String(currentValue).trim();

        const isDuplicate = this.props.pageStateArray.some(
          (row, idx) =>
            idx !== index &&
            String(row.eway_bill_no || "").trim() === normalized
        );

        if (isDuplicate) {
          e.preventDefault();

          this.setState({
            showErrorPopup: true,
            errorMessage: "Duplicate E-Way Bill number is not allowed.",
          });

          setTimeout(() => {
            this.props.makeFocusOnParticularFieldForItem(
              this.props.fieldMapping,
              index,
              "eway_bill_no"
            );
          }, 0);

          return;
        }
      }
    }

    if (fieldInfoObject.name == "unit" && keyString == "Enter") {
      if ("rate_info" in this.props.pageStateArray[index]) {
        this.props.setOverlay(true);
        let rateInfoObject = this.props.pageStateArray[index]["rate_info"];
        for (let i = 0; i < rateInfoObject.length; i++) {
          if (
            rateInfoObject[i].unit.toUpperCase() ==
            this.props.pageStateArray[index].unit.toUpperCase()
          ) {
            if (
              "rate" in rateInfoObject[i] &&
              this.props.pageStateArray[index].unit.toUpperCase() != "F" &&
              !(process.env.REACT_APP_CLIENT === "bvtc" && this.props.disableRateInfoAutoFill)
            ) {
              this.handleChangeByField("rate", rateInfoObject[i].rate, index);
            }
            if ("weight" in rateInfoObject[i]) {
              this.handleChangeByField(
                "weight",
                rateInfoObject[i].weight,
                index
              );
            }
          }
        }
        this.props.setOverlay(false);
      }
    }


    if (fieldInfoObject.name == "weight" && keyString == "Enter") {
      console.log("In weight :- ", this.props.pageStateArray);
      console.log("In weight  index:- ", index);
      if (
        !(process.env.REACT_APP_CLIENT === "bvtc" && this.props.disableRateInfoAutoFill) &&
        "rate_info" in this.props.pageStateArray[index] &&
        this.props.pageStateArray[index].unit.toUpperCase() == "F"
      ) {
        let rateInfoObject = this.props.pageStateArray[index]["rate_info"];
        console.log("rate info object Before :- ", rateInfoObject);
        let truckSizeRateMatched = false;
        for (let i = 0; i < rateInfoObject.length; i++) {
          console.log("rate info object :- ", rateInfoObject[i]);
          if (
            "rate" in rateInfoObject[i] &&
            this.props.pageStateArray[index].truck_size ==
              rateInfoObject[i].truck_size &&
            rateInfoObject[i].unit.toUpperCase() == "F"
          ) {
            truckSizeRateMatched = true;
            this.handleChangeByField("rate", rateInfoObject[i].rate, index);
            // rateValue[rateInfoObject[i].truck_size] = rateInfoObject[i].rate
          }
        }
        if (!truckSizeRateMatched) {
          const anyFixedRate = rateInfoObject.find(
            (info) =>
              "rate" in info &&
              info.unit &&
              info.unit.toUpperCase() == "F"
          );
          if (anyFixedRate) {
            this.handleChangeByField("rate", anyFixedRate.rate, index);
          }
        }
      }
    }

    // Ewaybill info update block
    if (
      fieldInfoObject.name == "new_row" &&
      this.props.fieldMapping == "eway_bill_no" &&
      keyString == "Enter"
    ) {

      if (
        this.props.pageStateArray[index].new_row == "n" ||
        this.props.pageStateArray[index].new_row == "N"
      ) {
        let apiInputData = [];
        let dummyEwbObject = {};
        let ewbEmpty = false;
        for (let i = 0; i < this.props.pageStateArray.length; i++) {
          dummyEwbObject = this.props.pageStateArray[i];
          if (dummyEwbObject.eway_bill_no == "") {
            ewbEmpty = true;
            break;
          }
          apiInputData.push({ eway_bill_no: dummyEwbObject.eway_bill_no });
        }
        if (!ewbEmpty) {
          this.props.refStoreObject.current.eway_bill_no[index].new_row.blur();
          console.log("api input data", apiInputData);
          console.log("asassadasd", this.props);
          this.props.setOverlay(true);
          let data = {
            apiUrlTail:
              "?branch_id=" +
              JSON.parse(sessionStorage.branch_id).branch_id,
            apiType: "getEwbInfo",
            apiConfig: this.props.apiConfig,
            apiInputData: apiInputData,
          };
          if (this.props.pageState.bilty_id != "") {
            data.apiUrlTail =
              "?bilty_id=" +
              this.props.pageState.bilty_id +
              "&branch_id=" +
              JSON.parse(sessionStorage.branch_id).branch_id;
          }
          this.props.performSuggestions(data).then(() => {
            if (process.env.REACT_APP_CLIENT === "bgtc") {
              this.props.makeFocusOnParticularField("station_to_name");
            }
          });
          return;
        }
      }
    }

    if (
      fieldInfoObject.name == "new_row" &&
      this.props.fieldMapping == "item_in" &&
      keyString == "Enter"
    ) {
      if (
        this.props.pageStateArray[index].new_row == "n" ||
        this.props.pageStateArray[index].new_row == "N"
      ) {
        this.props.fetchChargeRate();
        return;
      }
    }

    // Keyboard navigation block
    if (
      "keyboardNavigationMap" in fieldInfoObject &&
      keyString in fieldInfoObject.keyboardNavigationMap
    ) {
      e.preventDefault();
      /**
       * For all the boxes which are not end box, shift the focus.
       * If it is end box, conditional nav flag needs to be there.
       */
      if (
        !("conditionalNav" in fieldInfoObject.keyboardNavigationMap[keyString])
      ) {
        if (
          fieldInfoObject.name == "weight" &&
          this.props.pageState.pay_type == "4" &&
          process.env.REACT_APP_CLIENT != "nrab" &&
          parseInt(process.env.REACT_APP_BILTY_DISABLE_DYNAMIC_TABLE_IN_TBB_MODIFY)
        ) {
          this.props.makeFocusOnParticularFieldForItem(
            this.props.fieldMapping,
            index,
            "new_row"
          );
          return;
        }
        if (
          fieldInfoObject.name == "unit" &&
          (this.props.pageStateArray[index].unit == "f" ||
            this.props.pageStateArray[index].unit == "F") &&
          (this.props.tableItems.find((t) => t.name == "truck_size")?.type ??
            "dropdown") != "checkbox"
        ) {
          this.props.makeFocusOnParticularFieldForItem(
            this.props.fieldMapping,
            index,
            "truck_size"
          );
          return;
        }
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          fieldInfoObject.keyboardNavigationMap[keyString].nextField
        );
        return;
      }

      /***
       * If end row or not
       */
      if (index + 1 == totalLength) {
        let valueForNav = this.props.pageStateArray[index].new_row;
        if (valueForNav == "y" || valueForNav == "Y") {
          /**
           * Check if any field is empty and don't let the row add
           * if any field is empty.
           */
          for (var item_index in this.props.pageStateArray) {
            let item = this.props.pageStateArray[item_index];
            for (var key in item) {
              if (item[key] == "") {
                if (key == "rate_info") {
                  continue;
                }
                if (key == "truck_size") {
                  continue;
                }
                return;
              }
            }
          }
          this.handleAddRow();
          return;
        } else if (valueForNav == "n" || valueForNav == "N") {
          /**
           * Make focus to anywhere else.
           */
          this.props.makeFocusOnParticularField(
            fieldInfoObject.keyboardNavigationMap[keyString].nextFieldOnPage
          );
          return;
        }
      } else {
        // Not end row
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index + 1,
          fieldInfoObject.keyboardNavigationMap[keyString].nextField
        );
        return;
      }
    }
  };

  getAdditionalInfoForSuggestionFetch = () => {
    let additionalInfoObject = {};
    additionalInfoObject.station_from = this.props.pageState.station_from;
    additionalInfoObject.station_to = this.props.pageState.station_to;
    if (this.props.pageState.pay_type == "4") {
      additionalInfoObject.consignor_id = this.props.pageState.consignor_id;
      additionalInfoObject.consignee_id = null;
    } else {
      additionalInfoObject.consignor_id = null;
      additionalInfoObject.consignee_id = this.props.pageState.consignee_id;
    }
    return additionalInfoObject;
  };

  getShouldRenderSugggestions = (fieldInfo) => {
    if ("suggestionsOff" in fieldInfo && fieldInfo.suggestionsOff == true) {
      return false;
    } else {
      return true;
    }
  };

  checkToBeBilledCondition = (fieldInfo, idx) => {
    //This If Removed to see Rate and Amount value by normal user 

    // if (
    //   this.props.pageState.pay_type == "4" &&
    //   (fieldInfo.name == "rate" || fieldInfo.name == "amount") &&
    //   this.props.pageState.role_id != "1"
    // ) {
    //   return false;
    // } 

    if (
      this.props.formName === "Bilty Inquiry" &&
      process.env.REACT_APP_CLIENT === "bgtc" &&
      ![1, 2].includes(Number(this.props.pageState?.role_id)) &&
      [2, 4].includes(Number(this.props.pageState?.pay_type)) &&
      ["rate", "amount"].includes(fieldInfo.name)
    ) {
      return false;
    }

    if (
      fieldInfo.name == "truck_size" &&
      fieldInfo.type == "checkbox"
    ) {
      return true;
    }

    if (
      String(this.props.pageStateArray[idx].unit).toUpperCase() != "F" &&
      fieldInfo.name == "truck_size"
    ) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    return (
      <div>
        <div className="dt-container  responsive-table">
          <div className="row clearfix">
            <div className="col-md-12 column">
              <table
                className="table table-bordered table-hover"
                id="tab_logic"
              >
                <thead>
                  <tr>
                    <th />
                    {this.props.tableHeader.map((item) => (
                      <th className={item.className} key={item.label}>
                        {" "}
                        {item.label}{" "}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {this.props.pageStateArray.map((item, idx) => (
                    <tr id="addr0" key={idx}>
                      <td>
                        <button
                          className="item-remove-btn"
                          onClick={this.handleRemoveSpecificRow(idx)}
                        >
                          -
                        </button>
                      </td>

                      <td>{idx + 1}</td>
                      {this.props.tableItems.map((row, index) => {
                        if (row["type"] === "checkbox") {
                          return (
                            <td key={idx + row.name}>
                              {this.checkToBeBilledCondition(row, idx) && (
                                <input
                                  type="checkbox"
                                  checked={
                                    String(
                                      this.props.pageStateArray[idx][
                                        row["name"]
                                      ] ?? ""
                                    ).toUpperCase() === "BIG"
                                  }
                                  disabled={
                                    this.props.pageMode == "view" ||
                                    this.props.disabledFlag == "true" ||
                                    ("isDisabled" in row &&
                                      row.isDisabled({
                                        pageState: this.props.pageState,
                                        pageMode: this.props.pageMode,
                                        idx,
                                      }))
                                      ? "disabled"
                                      : ""
                                  }
                                  onChange={(e) => {
                                    this.handleChangeByField(
                                      row["name"],
                                      e.target.checked ? "BIG" : "",
                                      idx
                                    );
                                  }}
                                  ref={(a) =>
                                    this.props.storeInputReferenceForSelectForDynamicTable(
                                      a,
                                      row["name"],
                                      idx,
                                      this.props.fieldMapping
                                    )
                                  }
                                  onKeyPress={(e) => {
                                    this.onKeyPress(
                                      e,
                                      idx,
                                      this.props.pageStateArray.length,
                                      row
                                    );
                                  }}
                                />
                              )}
                            </td>
                          );
                        } else if (row["type"] === "dropdown") {
                          return (
                            <td key={idx + row.name}>
                              {this.checkToBeBilledCondition(row, idx) && (
                                <select
                                  className={row["inputClassName"]}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    this.handleChangeByField(
                                      row["name"],
                                      value,
                                      idx
                                    );
                                  }}
                                  // have introduced new function to disable individual drop downs
                                  disabled={
                                    this.props.pageMode == "view" ||
                                    this.props.disabledFlag == "true"||
                                    ("isDisabled" in row && row.isDisabled({ pageState: this.props.pageState, pageMode: this.props.pageMode, idx })) 
                                      ? "disabled"
                                      : ""
                                  }
                                  value={
                                    this.props.pageStateArray[idx][row["name"]]
                                  }
                                  ref={(a) =>
                                    this.props.storeInputReferenceForSelectForDynamicTable(
                                      a,
                                      row["name"],
                                      idx,
                                      this.props.fieldMapping
                                    )
                                  }
                                  onKeyPress={(e) => {
                                    this.onKeyPress(
                                      e,
                                      idx,
                                      this.props.pageStateArray.length,
                                      row
                                    );
                                  }}
                                >
                                  {row["dropdown_items"].map(
                                    (dropdown_item) => (
                                      <option
                                        value={dropdown_item.value}
                                        key={dropdown_item.label}
                                      >
                                        {dropdown_item.label}
                                      </option>
                                    )
                                  )}
                                </select>
                              )}
                            </td>
                          );
                        } else {
                          return (
                            <td key={idx + row.name}>
                              {this.checkToBeBilledCondition(row, idx) && (
                                <Autosuggest
                                  id={row["name"] + "#" + idx}
                                  // suggestions={this.props.suggestions}
                                  suggestions = {(this.props.suggestions != undefined) ? this.props.suggestions : ""}  // changes made for removing error that was caused by undefined suggestion
                                  onSuggestionsFetchRequested={(a) =>
                                    this.props.onSuggestionsFetchRequested(
                                      a,
                                      (b) =>
                                        this.props.suggestionFetchApi(
                                          row,
                                          b,
                                          this.getAdditionalInfoForSuggestionFetch()
                                        )
                                    )
                                  }
                                  onSuggestionsClearRequested={() =>
                                    this.props.onSuggestionsClearRequested(row)
                                  }
                                  shouldRenderSuggestions={() =>
                                    this.getShouldRenderSugggestions(row)
                                  }
                                  getSuggestionValue={(suggestion) =>
                                    suggestion[row.suggestionKeyword]
                                  }
                                  onSuggestionSelected={(a, b) =>
                                    this.props.getSuggestionValue(
                                      b.suggestion,
                                      row,
                                      this.props.performSuggestions,
                                      (d) =>
                                        this.updateSuggestionValueInState(
                                          idx,
                                          d
                                        ),
                                      idx
                                    )
                                  }
                                  renderSuggestion={(a) =>
                                    this.props.renderSuggestion(a, row)
                                  }
                                  highlightFirstSuggestion={true}
                                  ref={(a) => {
                                    this.props.storeInputReference(
                                      a,
                                      true,
                                      this.props.fieldMapping
                                    );
                                    if (
                                      "newRowFocus" in row &&
                                      row["newRowFocus"]
                                    ) {
                                      if (
                                        a != null &&
                                        this.state.focusOnAddRow
                                      ) {
                                        a.input.focus();
                                        this.setState({
                                          focusOnAddRow: false,
                                        });
                                      }
                                    }
                                  }}
                                  inputProps={{
                                    placeholder: row["placeHolder"], // Ensure this is set correctly
                                    value: String(this.props.pageStateArray[idx][row["name"]]),
                                    onChange: (a, b) => {
                                      this.props.onChangeAutoSuggest(
                                        a,
                                        b,
                                        row,
                                        (c, d) =>
                                          this.handleChangeByField(c, d, idx)
                                      );
                                    },
                                    onBlur: () => {
                                      row["toValidate"]
                                        ? this.props.onblurValidatorForTable(
                                            this.props.fieldMapping,
                                            idx,
                                            row["name"]
                                          )
                                        : {};
                                      if (
                                        typeof this.props.onFieldBlur ===
                                        "function"
                                      ) {
                                        const blurResult = this.props.onFieldBlur(
                                          idx,
                                          row["name"],
                                          this.props.pageStateArray[idx]
                                        );
                                        if (
                                          blurResult &&
                                          blurResult.revertTo !== undefined
                                        ) {
                                          this.handleChangeByField(
                                            row["name"],
                                            blurResult.revertTo,
                                            idx
                                          );
                                        }
                                      }
                                    },
                                    onKeyDown: (e) => {
                                      this.onKeyPress(
                                        e,
                                        idx,
                                        this.props.pageStateArray.length,
                                        row
                                      );
                                    },
                                    disabled:
                                      this.props.pageMode == "view" ||
                                      this.props.disabledFlag == "true" ||
                                      ("isDisabled" in row && row.isDisabled({ pageState: this.props.pageState, pageMode: this.props.pageMode, idx })) 
                                      ? "disabled"
                                        : "",
                                    className: row.className,
                                  }}
                                />
                              )}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  ))}
                  <tr>
                    <td>
                      {!(
                        process.env.REACT_APP_CLIENT === "bgtc" &&
                        this.props.fieldMapping === "item_in" &&
                        this.props.pageStateArray.length >= 6
                      ) && (
                        <button
                          onClick={this.handleAddRow}
                          className="item-add-btn"
                        >
                          +
                        </button>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* <button
                onClick={this.handleRemoveRow}
                className="btn btn-danger float-right item-remove-btn"
              >
                Delete Last Row
              </button> */}
            </div>
          </div>
        </div>

        <Popup
          open={this.state.showErrorPopup}
          modal
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                <div>Error</div>
                <div>
                  <a
                    className="pop-up-close btn"
                    onClick={() => {
                      this.setState({ showErrorPopup: false });
                      close();
                    }}
                  >
                    &times;
                  </a>
                </div>
              </div>

              <div className="pop-up-content">
                <div className="pop-up-fields">
                  <div className="pop-up-field">
                    <div className="pop-up-field-label">Message: </div>
                    <div className="pop-up-field-value">
                      {this.state.errorMessage}
                    </div>
                  </div>
                </div>
              </div>

              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    this.setState({ showErrorPopup: false });
                    close();
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default DynamicTable;
